import { render, staticRenderFns } from "./Provisioning-SMS-Activity.vue?vue&type=template&id=2019f9a2"
import script from "./Provisioning-SMS-Activity.vue?vue&type=script&lang=js"
export * from "./Provisioning-SMS-Activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports